<template>
  <div class="page">
    <el-form
        v-if="send"
      :model="queryForm"
      ref="form"
      label-width="80px"
      :inline="true"
      size="small"
      class="query-form"
      @submit.native.prevent
    >
      <el-form-item label="查询节点">
        <el-input
          v-model="queryForm.areaName"
          placeholder="区域名称"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="checkState = 'check'"
        >查询</el-button>
        <el-button
          size="small"
          icon="el-icon-refresh"
          @click="checkState = 'reset'"
        >重置</el-button>
      </el-form-item>
    </el-form>
    <AreaListTable :data="this.data" @send="getData" :queryForm="queryForm" :checkState="checkState" :areaList="areaList" @resetCheckState="resetCheckState"></AreaListTable>
  </div>
</template>

<script>
import AreaListTable from '@/components/system/AreaListTable.vue';
export default {
    components: {
        AreaListTable
    },
    data() {
        return {
            queryForm: {
                areaName: ''
            },
            form: {},
            data: '',
            areaList: [],
            checkState: '',
            send: ''
        };
    },
    methods: {
        getData(data) {
            this.send = data;
        },
        resetCheckState() {
            if (this.checkState == 'reset') {
                this.queryForm = {
                    deptName: ''
                };
            }
            this.checkState = '';
        }
    }
};
</script>

<style lang="scss" scoped></style>
